import { render, staticRenderFns } from "./Register2.vue?vue&type=template&id=2bb53c5c&scoped=true"
import script from "./Register2.vue?vue&type=script&lang=ts"
export * from "./Register2.vue?vue&type=script&lang=ts"
import style0 from "./Register2.vue?vue&type=style&index=0&id=2bb53c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb53c5c",
  null
  
)

export default component.exports